import type { Card } from '../types/solver'

export const RANKS_ASC = '23456789TJQKA'
export const RANKS_DESC = 'AKQJT98765432'
export const SUITS = 'cdhs'

const suitSymbols: Record<string, string> = {
  c: '♣',
  d: '♦',
  h: '♥',
  s: '♠',
}

export function cardToId(card: Card): number {
  if (!/^[2-9TJQKA][cdhs]$/.test(card)) throw new Error(`不正なカード: ${card}`)
  const rank = RANKS_ASC.indexOf(card[0])
  const suit = SUITS.indexOf(card[1])
  return rank * 4 + suit
}

export function idToCard(id: number): Card {
  if (!Number.isInteger(id) || id < 0 || id >= 52) throw new Error(`不正なカードID: ${id}`)
  return `${RANKS_ASC[Math.floor(id / 4)]}${SUITS[id & 3]}`
}

export function displayCard(card: Card): string {
  return `${card[0]}${suitSymbols[card[1]] ?? card[1]}`
}

export function isRedCard(card: Card): boolean {
  return card[1] === 'd' || card[1] === 'h'
}

export function cardPairToIndex(cardA: number, cardB: number): number {
  const card1 = Math.min(cardA, cardB)
  const card2 = Math.max(cardA, cardB)
  if (card1 === card2 || card1 < 0 || card2 >= 52) throw new Error('ホールカードが不正です')
  return (card1 * (101 - card1)) / 2 + card2 - 1
}

export function packedCardsToCombo(packed: number): string {
  const card1 = packed & 0xff
  const card2 = (packed >>> 8) & 0xff
  return [card1, card2]
    .sort((a, b) => b - a)
    .map(idToCard)
    .join('')
}

export function comboCards(combo: string): [Card, Card] {
  if (!/^[2-9TJQKA][cdhs][2-9TJQKA][cdhs]$/.test(combo)) {
    throw new Error(`不正なコンボ: ${combo}`)
  }
  return [combo.slice(0, 2), combo.slice(2, 4)]
}

export function validateBoard(cards: Card[]): void {
  const ids = cards.map(cardToId)
  if (new Set(ids).size !== ids.length) throw new Error('ボードに同じカードが含まれています')
}
